import styled, { type DefaultTheme } from 'styled-components'

import { Badge, BadgeColorKeys } from '@/components/ui/badge'

const removeHoverColorMap: Record<BadgeColorKeys, keyof DefaultTheme['colors']> = {
  blue: 'blue300',
  green: 'green300',
  neutral: 'gray400',
  orange: 'orange300',
  purple: 'purple300',
  red: 'red300',
  turquoise: 'turquoise300',
}

export const Chip = styled(Badge)<{ $readOnly?: boolean }>(({ $readOnly }) => ({
  alignItems: 'center',
  cursor: $readOnly ? 'not-allowed' : undefined,
  gap: '0.4rem',
  maxWidth: '20rem',
  userSelect: 'none',
}))

export const ChipLabel = styled.span(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const ChipRemove = styled.button<{ $color: BadgeColorKeys }>(({ theme, $color }) => ({
  '&:hover': {
    backgroundColor: theme.colors[removeHoverColorMap[$color]],
  },
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '50%',
  color: 'inherit',
  cursor: 'pointer',
  display: 'inline-flex',
  flexShrink: 0,
  justifyContent: 'center',
  outline: 'none',
  padding: '0.1rem',
  transition: `background-color ${theme.transition.duration.sm} ease`,
}))
